import api from '.';

export interface Request {
  email: string;
  password: string;
}

export interface Response {
  data: { token: string };
}

export async function verifySCGUser(accessToken: string) {
  const params = { permission: true };
  const { data } = await api.get(
    `${process.env.REACT_APP_PROJECT_REGISTER_URL}/auth/login-scg-azure`,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params
    }
  );

  return data;
}

export async function signInExt(request: Request) {
  const { data } = await api.post(
    `${process.env.REACT_APP_PROJECT_REGISTER_URL}/auth/login`,
    request
  );

  return data;
}
